import { isEqual } from 'lodash-es'
import type { DataLayerProduct } from '@@/shared-components/types/DataLayer'

export function useUtils() {
  // ARGS se odvozuje z tvaru `fn`; původní `T extends (...args: ARGS[]) => void`
  // nešlo inferovat a každý callback vycházel jako `(...args: unknown[]) => void`.
  function debounce<ARGS extends unknown[]>(
    fn: (...args: ARGS) => void,
    ms = 300
  ): (...args: ARGS) => void {
    let timeoutId: NodeJS.Timeout

    return function (this: unknown, ...args: ARGS) {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => fn.apply(this, args), ms)
    }
  }

  const useMemoizeComputed = <T>(fn: () => T): ComputedRef<T> => {
    let prev: T
    return computed(() => {
      const result = fn()
      if (prev !== undefined && isEqual(result, prev)) {
        return prev
      }
      prev = result
      return result
    })
  }

  function getAllCategories(product: DataLayerProduct) {
    const categories: string[] = []

    for (const category in product?.categories) {
      const titles = product.categories[category]?.map((item) => item.title) ?? []
      categories.push(...titles)
    }

    const categoryObject: { [key: string]: string } = {}
    categories.forEach((title, index) => {
      if (index > 0) {
        categoryObject[`item_category${index + 1}`] = title
      } else {
        categoryObject['item_category'] = title
      }
    })

    return categoryObject
  }

  return {
    debounce,
    useMemoizeComputed,
    getAllCategories,
  }
}
